import { render, staticRenderFns } from "./WordPressDevelopment.vue?vue&type=template&id=5e35d9bb&"
import script from "./WordPressDevelopment.vue?vue&type=script&lang=js&"
export * from "./WordPressDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports